<template>
  <CadastroBase
    nomePlural="SupportTeamMembers"
    nomeSingular="SupportTeamMember"
    :submitPersonalizado="true"
    @submitSuccessInsert="emitSubmitSuccess"
    @submitErrorInsert="emitSubmitError"
    @closeModalInsert="closeModal"
  >
    <v-col cols="12">
      <v-row>
        <v-col cols="12">
          <TabelaSelecionaRecurso
            :payload="recurso.pessoa"
            :headers="headersPessoa"
            url="pessoas"
            cadastro-url="cadastro.Pessoa"
            titulo="Pessoa"
            @recurso="recurso.pessoa = $event"
          />
        </v-col>

        <v-col cols="12" md="6">
          <v-checkbox v-model="recurso.notificarNovo">
            <template v-slot:label>
              {{ $t("Notificar_novo_ticket") }}
            </template>
          </v-checkbox>
        </v-col>

        <v-col cols="12" md="6">
          <v-checkbox v-model="recurso.ativo">
            <template v-slot:label>
              {{ $t("Ativo") }}
            </template>
          </v-checkbox>
        </v-col>
      </v-row>
    </v-col>
  </CadastroBase>
</template>

<script>
import CadastroBase from "@/components/base/Crud/CadastroBase";
import TabelaSelecionaRecurso from "@/components/base/proprios/TabelaSelecionaRecurso";
import { createSupportTeamMemberDataService } from "@/services/support/SupportTeamMemberDataService";

export default {
  name: "CadastroSupportTeamMember",
  components: {
    CadastroBase,
    TabelaSelecionaRecurso,
  },
  data() {
    const supportScope =
      this.$route?.meta?.supportScope || this.$route?.query?.escopo || null;
    return {
      DataService: createSupportTeamMemberDataService(supportScope),
      recurso: {
        pessoa: {},
        notificarNovo: true,
        ativo: true,
      },
      headersPessoa: [
        { text: this.$t("Nome"), value: "nome", sortable: "true" },
        { text: this.$t("CPF"), value: "cpf", sortable: "false" },
        { text: this.$t("Email"), value: "email", sortable: "false" },
      ],
    };
  },
  methods: {
    emitSubmitSuccess() {
      this.$emit("submitSuccessInsert");
    },
    emitSubmitError() {
      this.$emit("submitErrorInsert");
    },
    closeModal() {
      this.$emit("closeModalInsert");
    },
    buildPayload() {
      return {
        pessoa: this.recurso?.pessoa?.id
          ? { id: this.recurso.pessoa.id }
          : null,
        notificarNovo: this.recurso.notificarNovo === true,
        ativo: this.recurso.ativo === true,
      };
    },
    validatePayload() {
      const errors = [];

      if (!this.recurso?.pessoa?.id) {
        errors.push({
          fieldName: "Pessoa",
          message: "Mandatory field",
        });
      }

      return errors;
    },
    submitForm() {
      return new Promise((resolve, reject) => {
        const errors = this.validatePayload();
        if (errors.length > 0) {
          reject(errors);
          return;
        }

        this.DataService.create(this.buildPayload())
          .then(() => {
            resolve();
          })
          .catch((error) => {
            reject(
              error?.response?.data?.errors || [
                {
                  fieldName: "SupportTeamMember",
                  message: "Erro ao salvar registro.",
                },
              ]
            );
          });
      });
    },
  },
};
</script>

<style scoped></style>
